import React, { useCallback } from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets.ts';

import { RovoAnnouncementSplashModalComponent } from './RovoAnnouncementSplashComponent.tsx';
import { RovoAnnouncementSplashSuppressor } from './RovoAnnouncementSplashSuppressor.tsx';

type RovoAnnouncementSplashContainerProps = {
	onModalShown?: (dismissSource: string) => void;
};

export const RovoAnnouncementSplashContainer: React.FC<RovoAnnouncementSplashContainerProps> = ({
	onModalShown = () => {},
}) => {
	const { Modal } = useChoreographerAssets();

	const onModalClose = useCallback(() => {
		onModalShown('outsideModal');
	}, [onModalShown]);

	return (
		<RovoAnnouncementSplashSuppressor>
			<ModalTransition>
				<Modal
					messageType="marketing"
					messageId="rovo-announcement-splash-modal"
					width="x-large"
					height={568}
					onClose={onModalClose}
					shouldCloseOnOverlayClick
					shouldCloseOnEscapePress
				>
					<RovoAnnouncementSplashModalComponent onModalShown={onModalShown} />
				</Modal>
			</ModalTransition>
		</RovoAnnouncementSplashSuppressor>
	);
};
